module.exports = __webpack_public_path__ + "img/icon_eliminar_responsable.c8a4725d.svg";